import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    loadingHeader: {
        borderRadius: '16px',
        background: theme.palette.lightGrey.backgroundLight,
        width: '100%',
        height: '40px',
        margin: '20px auto 32px auto',
    },
    stepContainerLoading: {
        borderRadius: '22px',
        background: theme.palette.lightGrey.backgroundLight,
        width: '100%',
        height: '500px',
        '@media (min-width:1800px)': {
            height: '700px',
        },
    },
    stepperContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        marginTop: '-2rem',
        overflowX: 'visible',
        '@media (max-width:700px)': {
            marginTop: '-8rem',
            padding: '0 !important',
            width: '100vw !important',
            marginLeft: 'calc(-50vw + 50%) !important',
            boxSizing: 'border-box',
        },
        '@media (max-width:1500px)': {
            marginTop: '-3rem',
            padding: '0 12px',
            boxSizing: 'border-box',
        },
    },
    stepperContent: {
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        overflowX: 'visible',
        boxSizing: 'border-box',
        '& .MuiListItemButton-root, & .MuiMenuItem-root, & [role="option"]': {
            '&:hover': {
                background: `${theme.palette.gradients.hoverGradient} !important`,
            },
            '& .MuiTouchRipple-child': {
                backgroundColor: theme.palette.purple.rippleLight,
            },
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: theme.palette.lightGrey.borderLight,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.expertise.main,
                borderWidth: '2px',
            },
        },
        '@media (max-width:700px)': {
            padding: '0 !important',
            maxWidth: '100% !important',
        },
    },
    stepper: {
        marginBottom: '44px',
        '& .MuiStep-root': {
            paddingLeft: '4px',
            paddingRight: '4px',
        },
        '& .MuiStepLabel-label': {
            marginTop: '3px',
            textAlign: 'center',
            wordBreak: 'break-word',
            fontFamily: 'AvertaPE-Bold',
            fontSize: '14px',
            fontWeight: 400,
            color: theme.palette.typography.stepLabel,
        },
        '& .MuiStepLabel-label.Mui-active': {
            color: theme.palette.typography.stepActive,
            fontWeight: 700,
            fontFamily: 'AvertaPE-Bold',
        },
        '& .MuiStepLabel-label.Mui-completed': {
            color: theme.palette.typography.stepCompleted,
        },
        '& .MuiStepIcon-root': {
            color: theme.palette.lightGrey.stepIcon,
            '&.Mui-active': {
                color: theme.palette.expertise.main,
            },
            '&.Mui-completed': {
                color: theme.palette.expertise.main,
            },
            '& .MuiStepIcon-text': {
                fill: theme.palette.white.main,
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                fontWeight: 500,
            },
        },
        '& .MuiButtonBase-root': {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
        },
        '@media (max-width:700px)': {
            marginBottom: '24px',
            '& .MuiStepLabel-label': {
                fontSize: '10px',
                lineHeight: '13px',
                whiteSpace: 'nowrap',
            },
            '& .MuiStepIcon-root': {
                fontSize: '1.4rem',
            },
            '& .MuiStep-root': {
                padding: '0 1px',
                flex: 1,
                minWidth: 0,
            },
        },
    },
    stepContainer: {
        borderRadius: '22px',
        background: theme.palette.white.main,
        boxShadow: '0 16px 56px 0 rgba(52, 52, 52, 0.05)',
        display: 'flex',
        padding: '40px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        alignSelf: 'stretch',
        width: '100%',
        boxSizing: 'border-box',
        '@media (max-width:700px)': {
            padding: '20px 16px',
            borderRadius: '16px',
            boxShadow: '0 16px 56px 0 rgba(52, 52, 52, 0.05)',
        },
    },
    stepTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '18px',
        fontWeight: 600,
        color: theme.palette.typography.titleDark,
        margin: 0,
    },
    stepContent: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        fontFamily: 'AvertaPE-Regular',
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '40px',
        '@media (max-width:700px)': {
            fontSize: '24px',
            lineHeight: '32px',
        },
    },
    stepActions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        marginTop: '8px',
        '@media (max-width:700px)': {
            flexDirection: 'column-reverse',
            gap: '12px',
            alignItems: 'stretch',
        },
    },
    backButton: {
        padding: 0,
        minWidth: 'auto',
        textTransform: 'none',
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        '&:hover': {
            background: 'transparent',
        },
        '& svg': {
            flexShrink: 0,
        },
        '&.Mui-disabled': {
            color: '#B8B8B8',
        },
        '@media (max-width:700px)': {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },
    nextButton: {
        borderRadius: '8px',
        padding: '8px 24px',
        backgroundColor: theme.palette.expertise.main,
        color: theme.palette.white.main,
        textTransform: 'none',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.expertise.buttonHover,
        },
        '&.Mui-disabled': {
            backgroundColor: '#D5D7E1',
            color: '#FFFFFF',
            opacity: 1,
        },
        '@media (max-width:700px)': {
            width: '100%',
        },
    },
    completeButton: {
        borderRadius: '8px',
        padding: '8px 24px',
        backgroundColor: theme.palette.green.completeButton,
        color: theme.palette.white.main,
        textTransform: 'none',
        fontWeight: 500,
        marginLeft: '8px',
        '&:hover': {
            backgroundColor: theme.palette.green.completeButtonHover,
        },
    },
    patientLabel: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '32px',
        fontWeight: 700,
        lineHeight: '40px',
        color: theme.palette.typography.titleDark,
        marginBottom: '8px',
        '@media (max-width:700px)': {
            fontSize: '24px',
            lineHeight: '32px',
        },
    },
    searchResults: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 10,
        maxHeight: '300px',
        overflowY: 'auto',
        marginTop: '4px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    noResults: {
        padding: '24px 0',
        textAlign: 'center',
        maxWidth: '400px',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        margin: '0 auto',
    },
    noWorkflow: {
        padding: '24px 0',
        textAlign: 'center',
        maxWidth: '420px',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        margin: '0 auto',
    },
    patientName: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.typography.titleDark,
    },
    patientInfo: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '14px',
        color: theme.palette.typography.half,
    },
    patientList: {
        '& .MuiList-root': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiListItem-root': {
            borderBottom: `1px solid ${theme.palette.lightGrey.mediumDark}`,
            padding: 0,
        },
        '& .MuiListItem-root:last-child': {
            borderBottom: 'none',
        },
        '& .MuiListItemButton-root': {
            backgroundColor: theme.palette.lightGrey.cardBackground,
            padding: '14px 16px',
            '&:hover': {
                backgroundColor: `${theme.palette.lightGrey.cardBackground} !important`,
            },
        },
        maxHeight: '400px',
        overflowY: 'auto',
        borderRadius: '12px',
        border: `1.5px solid ${theme.palette.lightGrey.mediumDark}`,
    },
    selectedPatientName: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.expertise.main,
    },
    selectedPatient: {
        background: `${theme.palette.gradients.selectedGradient} !important`,
        boxShadow: '0 16px 56px 0 rgba(52, 52, 52, 0.05)',
        '&:hover': {
            background: `${theme.palette.gradients.selectedGradient} !important`,
        },
    },
    checkIcon: {
        color: theme.palette.expertise.main,
        marginRight: '8px',
    },
    resultsCount: {
        padding: '18px 16px 14px 16px',
        borderBottom: `1px solid ${theme.palette.lightGrey.mediumDark}`,
        backgroundColor: theme.palette.white.main,
        '& .MuiTypography-root': {
            fontSize: '14px',
            fontWeight: 600,
            color: theme.palette.lightGrey.darker,
            fontFamily: 'AvertaPE-Semibold',
        },
    },
    noPatient: {
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.lightGrey.darker,
        fontFamily: 'AvertaPE-Semibold',
        marginBottom: '12px',
    },
    resetFilter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '45px',
        padding: '12px 24px',
        borderRadius: '8px',
        backgroundColor: theme.palette.lightGrey.mediumDark,
        color: theme.palette.typography.main,
        fontSize: '16px',
        fontWeight: 700,
        fontFamily: 'AvertaPE-Semibold',
        marginBottom: '24px',
    },
    clearSearchIcon: {
        color: theme.palette.lightGrey.darker,
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.expertise.main,
        },
    },
    searchRequesterIcon: {
        width: '5.6rem',
        height: '5.6rem',
    },
    missingRpps: {
        color: '#FB7D08',
        fontSize: '14px',
        fontFamily: 'AvertaPE-Bold',
        marginBottom: 0,
    },
    disabledPatient: {
        cursor: 'not-allowed',
        background: '#FCFCFE !important',
        '&:hover': {
            background: '#FCFCFE !important',
        },
        '&.MuiListItemButton-root:hover': {
            background: '#FCFCFE !important',
        },
        '& .MuiTypography-root:not(.MuiTypography-h6):not($missingRpps):not($unavailableLabel):not($unavailableDate)': {
            color: '#B8B8B8 !important',
        },
        '& .MuiListItemText-primary': {
            color: '#B8B8B8 !important',
        },
        '& .MuiListItemText-secondary': {
            color: '#B8B8B8 !important',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    missingRppsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0px',
        padding: 0,
    },
    missingRppsButton: {
        display: 'flex',
        padding: '6px 16px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '6px',
        background: '#FB7D08',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '22px',
        letterSpacing: '0.17px',
        textTransform: 'none',
        '&:hover': {
            background: '#e86f00',
        },
    },
    missingRppsIcon: {
        marginRight: '6px',
        verticalAlign: 'middle',
    },
    consentTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: 700,
        color: '#313336',
        maxWidth: '700px',
        '@media (max-width:700px)': {
            fontSize: '28px',
            lineHeight: '36px',
        },
    },
    consentCards: {
        display: 'flex',
        gap: '16px',
        width: '100%',
        '@media (max-width:700px)': {
            flexDirection: 'column',
        },
    },
    consentCard: {
        position: 'relative',
        flex: 1,
        borderRadius: '12px',
        border: '1px solid #E5E9F2',
        padding: '16px 24px',
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'all .2s ease',
        background: '#FBFBFE',
        '&:hover': {
            border: '1px solid var(--greysurface-border-standard, #E5E9F2)',
            background: 'linear-gradient(0deg, #F5F5FF 0%, #F5F5FF 100%), #FFF',
        },
    },
    consentCardSelected: {
        border: '2px solid #575BAF',
        background: '#F5F5FF',
        '&:hover': {
            border: '2px solid #575BAF',
        },
    },
    consentCardError: {
        border: '2px solid #E53935',
        background: '#FFF5F5',
        '&:hover': {
            border: '2px solid #E53935',
        },
    },
    consentCardNoHoverRed: {
        '&:hover': {
            background: 'rgba(229, 57, 53, 0.08) !important',
            border: '2px solid #E53935 !important',
        },
    },
    consentCardTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        fontWeight: 700,
        color: '#1A1A1A',
        marginTop: '16px',
    },
    consentCardText: {
        fontFamily: 'AvertaPE-Regular',
        fontSize: '14px',
        lineHeight: '24px',
        color: '#4B5563',
        maxWidth: '270px',
        marginBottom: '16px',
        fontWeight: 400,
    },
    warningIcon: {
        position: 'absolute',
        right: '16px',
        bottom: '16px',
        color: '#E53935',
    },
    consentBackButton: {
        padding: 0,
        minWidth: 'auto',
        textTransform: 'none',
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: '12px',
        '&:hover': {
            background: 'transparent',
        },
        '& svg': {
            flexShrink: 0,
        },
    },
    consentHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
        alignSelf: 'stretch',
    },
    consentCardContent: {
        display: 'flex',
        minHeight: '60px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px',
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: '100%',
        boxSizing: 'border-box',
    },
    consentCheckIcon: {
        color: '#575BAF',
        fontSize: '24px',
        flexShrink: 0,
    },
    disableBackIcon: {
        width: '24px',
        height: '24px',
    },
    errorRoundedIcon: {
        width: '24px',
        height: '24px',
    },
    helpButton: {
        marginTop: '-20px',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: '#575BAF',
    },
    helpIcon: {
        marginTop: '24px',
        display: 'flex',
        justifyContent: 'center',
    },
    requesterDescription: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        color: '#4E5054',
    },
    helpRequesterContent: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        padding: '16px',
        width: '100%',
        borderRadius: '12px',
        border: '1.5px solid #24C3CF',
        background: '#F7FEFE',
        marginBottom: '16px',
        marginTop: '-7px',
        '& svg': {
            width: '24px',
            height: '24px',
            flexShrink: 0,
            marginTop: '1.5rem',
            marginRight: '10px',
        },
        '& .MuiTypography-root': {
            fontSize: '16px',
            lineHeight: '24px',
            fontFamily: 'AvertaPE-Bold',
            color: '#313336',
            flex: 1,
        },
    },
    helpRequesterTitle: {
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '21px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '29px',
        letterSpacing: '0.15px',
        margin: 0,
    },
    helpDialogPaper: {
        width: '100%',
        maxWidth: '745px',
        margin: '0 auto',
        borderRadius: '24px',
        '@media (max-width:700px)': {
            margin: '16px',
            width: 'calc(100% - 32px)',
            borderRadius: '16px',
        },
    },
    deleteText: {
        width: '100%',
        textAlign: 'left',
        alignSelf: 'flex-start',
        marginBottom: '24px',
        marginTop: '-9px',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    unavailableWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginLeft: '16px',
    },

    unavailableStatus: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
    },

    unavailableDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: '#FB7D08',
        marginTop: '7px',
        flexShrink: 0,
    },

    unavailableLabel: {
        color: '#FB7D08 !important',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '0.17px',
    },

    unavailableDate: {
        color: '#FB7D08 !important',
        fontFamily: 'AvertaPE-Regular',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '0.17px',
    },
    title: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '32px',
        lineHeight: '40px',
        color: '#313336',
        fontWeight: 700,
    },
    subtitle: {
        marginTop: '2px',
        marginBottom: '16px',
        fontFamily: 'AvertaPE-Regular',
        fontSize: '18px',
        lineHeight: '24px',
        color: '#4E5054',
        fontWeight: 600,
    },
    section: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 0',
        borderBottom: '1px solid #E7EBF0',
        '&:last-of-type': {
            borderBottom: 'none',
        },
    },
    sectionContent: {
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
        gap: '4px',
    },
    sectionLabel: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '14px',
        lineHeight: '22px',
        color: '#9EABBF',
        fontWeight: 600,
    },
    sectionTitle: {
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '18px',
        lineHeight: '28px',
        color: '#313336',
    },
    sectionSubtitle: {
        fontFamily: 'AvertaPE-Regular',
        fontSize: '16px',
        fontWeight: '400 !important',
        lineHeight: '24px',
        color: '#313336',
    },
    editButton: {
        minWidth: 'auto !important',
        width: 'auto',
        borderRadius: '8px',
        background: '#EEF1F7 !important',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        padding: '10px',
        '& svg': {
            width: '18px',
            height: '18px',
        },
    },
    initButton: {
        marginTop: '24px',
        marginBottom: '40px',
        width: '100%',
        borderRadius: '8px',
        minWidth: '168px',
        background: '#575BAF !important',
        color: '#FFF !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        padding: '18px 32px',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        '&:hover': {
            background: '#575BAF',
        },
    },
}))
